import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { DefaultService } from 'src/app/core/framework/default-service';
import { ErrorHandlerService } from 'src/app/core/framework/error-handler.service';
import { Tenant } from './model/tenant.model';


@Injectable({
  providedIn: 'root'
})
export class TenantService extends DefaultService<Tenant> {

  static URL = '/api/multitenancy/tenant/v1/tenant';

  constructor(
    public httpClient: HttpClient,
    public errorHandlerService: ErrorHandlerService
  ) {
    super(httpClient, errorHandlerService, TenantService.URL);
  }

  buscarTenantDoUsuarioLogado(): Observable<Tenant> {
    return this.httpClient.get<Tenant>(`${TenantService.URL}/buscarTenantDoUsuarioLogado`)
                          .pipe(
                            catchError( err => throwError(this.errorHandlerService.handle(err)) )
                          );
  }
}
